package com.exura.features.newauth.domain.model

data class ProviderAuthUser(
    override val id: String,
    override val email: String,
    val providerUserRole: ProviderUserRole,
) : AuthUser(
    userType = UserType.PROVIDER,
    userRole = providerUserRole.authRole,
)
